import * as Highcharts from 'highcharts';
import * as numeral from 'numeral';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ChartConfig, GraphConfig } from '../../../analytics-core/interfaces/chart.interface';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DaypartDonutComponent } from '../daypart-donut/daypart-donut.component';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
@Component({
	selector: 'app-ctv-dayparts-r1',
	styleUrls: ['./ctv-dayparts-r1.component.css'],
	templateUrl: './ctv-dayparts-r1.component.html'
})
export class CtvDaypartsR1Component extends DaypartDonutComponent {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;
	@ViewChild('chartElement') chartElement: ElementRef;

	@Input() sectiontitle: string;
	@Input() colorsconfig: any;
	@Input() chartconfiguration: any;
	@Input() sectionclass: any;
	@Input() nodatamessage: any;

	public reloadSubscription;
	public widgetDataSubscription;
	public key: string;
	public chartConfig: any;
	public colorPalette: ColorPalette;
	public showLoad = false;
	public hasData: boolean = true;
	public categories: any = [];
	public seriesData: any;
	public isR104: boolean = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		super.ngOnInit();
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
		this.requestData();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	processResponseData(responseData: any): void {
		this.daypartChartObjArray = this.buildDayPartChartCollatorByFields(responseData);
		this.daypartChartObjArray[0].chartObj.map((data, index) => {
			if (data.dayparttime) {
				data.color = this.getColorFromColorConfig(0, 1);
			}
		});

		this.generateGraph();
	}
	buildDayPartChartCollatorByFields(daypartResponseData: any): any[] {
		this.categories = [];
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		for (let index = 0; index < daypartResponseData.length; index++) {
			const chartObj: any = {};
			chartObj.name = daypartResponseData[index].daypart;
			chartObj.dayparttime = daypartResponseData[index].friendly_name;
			chartObj.y = Number(daypartResponseData[index].impressions);
			chartObj.displayOrder = daypartResponseData[index].display_order || index;
			chartObjArray.push(chartObj);
			this.categories.push(chartObj.name);
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		return fieldChartArray;
	}

	generateGraph(): void {
		this.chartObj = Highcharts.chart(this.chartElement.nativeElement, {
			chart: {
				margin: this.isR104 ? [100, 20, 100, 100] : []
			},
			credits: {
				enabled: false
			},
			legend: {
				align: this.chartConfig.graphConfig.legendConfig.align,
				itemHoverStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.fontWeight
				},
				itemStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemStyle.fontWeight
				},
				itemMarginBottom: this.chartConfig.graphConfig.legendConfig.itemMarginBottom
					? this.chartConfig.graphConfig.legendConfig.itemMarginBottom
					: 0,
				verticalAlign: this.chartConfig.graphConfig.legendConfig.verticalAlign,
				symbolRadius: this.chartConfig.graphConfig.legendConfig.symbolRadius
			},
			plotOptions: {
				column: {
					borderWidth: 2,
					pointWidth: this.chartConfig?.graphConfig?.legendConfig?.pointWidth,
					pointPadding: 0.2,
					borderRadius: this.chartConfig?.graphConfig?.legendConfig?.borderRadius
						? this.chartConfig.graphConfig.legendConfig.borderRadius
						: 0
				}
			},
			series: [
				{
					color: this.chartConfig?.seriesConfig[0]?.colorConfig
						? this.getColorFromColorConfiguration(this.chartConfig.seriesConfig[0].colorConfig)
						: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
					data: this.daypartChartObjArray[0].chartObj,
					dataLabels: {
						enabled: false
					},
					name: 'Impressions',
					showInLegend: true,
					states: {
						hover: {
							enabled: false
						},
						inactive: {
							opacity: 1
						}
					},
					type: this.chartConfig.seriesConfig[0].type
				}
			],
			title: {
				text: null
			},
			tooltip: {
				backgroundColor: this.chartConfig.seriesConfig[0].tooltipInfo[0].backgroundColor,
				borderColor: this.chartConfig?.seriesConfig[0]?.colorConfig
					? this.getColorFromColorConfiguration(this.chartConfig.seriesConfig[0].colorConfig)
					: this.isR104
					? this.colorPalette.primaryColor
					: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
				borderWidth: this.chartConfig.seriesConfig[0].tooltipInfo[0].borderWidth,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					return `<div class="dayparts-tooltip" style="text-align: center; font-size: 14px">
						<div style="padding-bottom: 5px;">${this.point['dayparttime']}</div>
						<div>${numeral(this.y).format('0,0')} impressions</div>
						</div>
					`;
				},
				padding: this.chartConfig.seriesConfig[0].tooltipInfo[0].padding,
				shadow: this.chartConfig.seriesConfig[0].tooltipInfo[0].shadow,
				style: {
					color: this.chartConfig.seriesConfig[0].tooltipInfo[0].style.color
				},
				useHTML: true
			},
			xAxis: {
				categories: this.categories,
				crosshair: false,
				tickLength: 0,
				labels: {
					padding: 15
				}
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Impressions',
					margin: this.isR104 ? 30 : 10
				}
			}
		});
	}

	private getColorFromColorConfiguration(colorConfig: ColorConfig): string {
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, colorConfig.opacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, colorConfig.opacity);
		}
		return rgb;
	}
}
